import reportingGraphqlRequest from '../reportingGraphqlRequest';
import GQL_DYSLEXIA_RISK_DATA from './assessmentDyslexiaRiskQuery';
import { mockedClassificationResponse } from '@/features/dashboard/models';
import GQL_ASSESSMENT_OUTCOMES_DATA from './assessmentOutcomesQuery';

interface AssessmentOutcomesData {
  classroomId: number; // make it required to ensure input is always provided
}

export const fetchAssessmentOutcomesData = async (params: AssessmentOutcomesData) => {
  const { classroomId } = params;
  if (!classroomId) {
    throw new Error('classroomId is required to fetch assessment outcomes data');
  }

  try {
    const response = await reportingGraphqlRequest(GQL_ASSESSMENT_OUTCOMES_DATA, {
      input: { classroomId }, // ensure input is passed correctly
    });

    // const mockResponse = mockedClassificationResponse;
    // return mockResponse;

    return response;
  } catch (error) {
    console.error('Error fetching assessment outcomes data', error);
    throw error; // rethrow the error for better error handling
  }
};

export const fetchAssessmentDyslexiaRiskData = async (classroomId: number) => {
  try {
    const response = await reportingGraphqlRequest(GQL_DYSLEXIA_RISK_DATA, {
      input: { classroomId },
    });
    return response;
  } catch (error) {
    console.error('Error fetching dyslexia risk data', error);
    throw error;
  }
};